/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { ExternalDealFilterMvoDTO } from "./ExternalDealFilterMvoDTO";
import {
  ExternalDealFilterMvoDTOFromJSON,
  ExternalDealFilterMvoDTOFromJSONTyped,
  ExternalDealFilterMvoDTOToJSON
} from "./ExternalDealFilterMvoDTO";
import type { ImageDTO } from "./ImageDTO";
import { ImageDTOFromJSON, ImageDTOFromJSONTyped, ImageDTOToJSON } from "./ImageDTO";
import type { OutDealProductDTO } from "./OutDealProductDTO";
import {
  OutDealProductDTOFromJSON,
  OutDealProductDTOFromJSONTyped,
  OutDealProductDTOToJSON
} from "./OutDealProductDTO";
import type { OutFilterDTO } from "./OutFilterDTO";
import { OutFilterDTOFromJSON, OutFilterDTOFromJSONTyped, OutFilterDTOToJSON } from "./OutFilterDTO";
import type { OutMerchantDTO } from "./OutMerchantDTO";
import { OutMerchantDTOFromJSON, OutMerchantDTOFromJSONTyped, OutMerchantDTOToJSON } from "./OutMerchantDTO";
import type { PublicPlatformDTO } from "./PublicPlatformDTO";
import {
  PublicPlatformDTOFromJSON,
  PublicPlatformDTOFromJSONTyped,
  PublicPlatformDTOToJSON
} from "./PublicPlatformDTO";

/**
 *
 * @export
 * @interface OutDealDTO
 */
export interface OutDealDTO {
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  id: number;
  /**
   * Exactly one EAN, no "|" list
   * @type {string}
   * @memberof OutDealDTO
   */
  ean?: string;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  sku?: string;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  slug?: string;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  url?: string;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  usp?: string;
  /**
   *
   * @type {boolean}
   * @memberof OutDealDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  currency?: string;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  stock?: number;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  scoreModifier?: number;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  score?: number;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  beforePrice?: number;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  discount?: number;
  /**
   *
   * @type {number}
   * @memberof OutDealDTO
   */
  sponsoredPosition?: number;
  /**
   *
   * @type {PublicPlatformDTO}
   * @memberof OutDealDTO
   */
  platform: PublicPlatformDTO;
  /**
   *
   * @type {Date}
   * @memberof OutDealDTO
   */
  lastSyncMoment?: Date;
  /**
   *
   * @type {Date}
   * @memberof OutDealDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {Date}
   * @memberof OutDealDTO
   */
  updatedAtByUser?: Date;
  /**
   *
   * @type {ImageDTO}
   * @memberof OutDealDTO
   */
  image?: ImageDTO;
  /**
   *
   * @type {OutMerchantDTO}
   * @memberof OutDealDTO
   */
  merchant?: OutMerchantDTO;
  /**
   *
   * @type {Array<OutFilterDTO>}
   * @memberof OutDealDTO
   */
  brands?: Array<OutFilterDTO>;
  /**
   *
   * @type {Array<OutFilterDTO>}
   * @memberof OutDealDTO
   */
  categories?: Array<OutFilterDTO>;
  /**
   * Admin endpoints only (/deals/extended, /deals/:id, write responses). Absent on public lists.
   * @type {Array<ExternalDealFilterMvoDTO>}
   * @memberof OutDealDTO
   */
  externalDealFilters?: Array<ExternalDealFilterMvoDTO>;
  /**
   *
   * @type {OutFilterDTO}
   * @memberof OutDealDTO
   */
  featuredFilter?: OutFilterDTO;
  /**
   *
   * @type {string}
   * @memberof OutDealDTO
   */
  createdBy: OutDealDTOCreatedByEnum;
  /**
   *
   * @type {OutDealProductDTO}
   * @memberof OutDealDTO
   */
  product?: OutDealProductDTO;
}

/**
 * @export
 */
export const OutDealDTOCreatedByEnum = {
  API: "API",
  DASHBOARD: "DASHBOARD",
  UNKNOWN: "UNKNOWN"
} as const;
export type OutDealDTOCreatedByEnum = typeof OutDealDTOCreatedByEnum[keyof typeof OutDealDTOCreatedByEnum];

/**
 * Check if a given object implements the OutDealDTO interface.
 */
export function instanceOfOutDealDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "name" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "createdBy" in value;

  return isInstance;
}

export function OutDealDTOFromJSON(json: any): OutDealDTO {
  return OutDealDTOFromJSONTyped(json, false);
}

export function OutDealDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutDealDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    sku: !exists(json, "sku") ? undefined : json["sku"],
    name: json["name"],
    slug: !exists(json, "slug") ? undefined : json["slug"],
    url: !exists(json, "url") ? undefined : json["url"],
    usp: !exists(json, "usp") ? undefined : json["usp"],
    live: json["live"],
    currency: !exists(json, "currency") ? undefined : json["currency"],
    stock: !exists(json, "stock") ? undefined : json["stock"],
    scoreModifier: !exists(json, "scoreModifier") ? undefined : json["scoreModifier"],
    score: !exists(json, "score") ? undefined : json["score"],
    price: !exists(json, "price") ? undefined : json["price"],
    beforePrice: !exists(json, "beforePrice") ? undefined : json["beforePrice"],
    discount: !exists(json, "discount") ? undefined : json["discount"],
    sponsoredPosition: !exists(json, "sponsoredPosition") ? undefined : json["sponsoredPosition"],
    platform: PublicPlatformDTOFromJSON(json["platform"]),
    lastSyncMoment: !exists(json, "lastSyncMoment") ? undefined : new Date(json["lastSyncMoment"]),
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    updatedAtByUser: !exists(json, "updatedAtByUser") ? undefined : new Date(json["updatedAtByUser"]),
    image: !exists(json, "image") ? undefined : ImageDTOFromJSON(json["image"]),
    merchant: !exists(json, "merchant") ? undefined : OutMerchantDTOFromJSON(json["merchant"]),
    brands: !exists(json, "brands") ? undefined : (json["brands"] as Array<any>).map(OutFilterDTOFromJSON),
    categories: !exists(json, "categories") ? undefined : (json["categories"] as Array<any>).map(OutFilterDTOFromJSON),
    externalDealFilters: !exists(json, "externalDealFilters")
      ? undefined
      : (json["externalDealFilters"] as Array<any>).map(ExternalDealFilterMvoDTOFromJSON),
    featuredFilter: !exists(json, "featuredFilter") ? undefined : OutFilterDTOFromJSON(json["featuredFilter"]),
    createdBy: json["createdBy"],
    product: !exists(json, "product") ? undefined : OutDealProductDTOFromJSON(json["product"])
  };
}

export function OutDealDTOToJSON(value?: OutDealDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    ean: value.ean,
    sku: value.sku,
    name: value.name,
    slug: value.slug,
    url: value.url,
    usp: value.usp,
    live: value.live,
    currency: value.currency,
    stock: value.stock,
    scoreModifier: value.scoreModifier,
    score: value.score,
    price: value.price,
    beforePrice: value.beforePrice,
    discount: value.discount,
    sponsoredPosition: value.sponsoredPosition,
    platform: PublicPlatformDTOToJSON(value.platform),
    lastSyncMoment: value.lastSyncMoment === undefined ? undefined : value.lastSyncMoment.toISOString(),
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    updatedAtByUser: value.updatedAtByUser === undefined ? undefined : value.updatedAtByUser.toISOString(),
    image: ImageDTOToJSON(value.image),
    merchant: OutMerchantDTOToJSON(value.merchant),
    brands: value.brands === undefined ? undefined : (value.brands as Array<any>).map(OutFilterDTOToJSON),
    categories: value.categories === undefined ? undefined : (value.categories as Array<any>).map(OutFilterDTOToJSON),
    externalDealFilters:
      value.externalDealFilters === undefined
        ? undefined
        : (value.externalDealFilters as Array<any>).map(ExternalDealFilterMvoDTOToJSON),
    featuredFilter: OutFilterDTOToJSON(value.featuredFilter),
    createdBy: value.createdBy,
    product: OutDealProductDTOToJSON(value.product)
  };
}
